import React from "react";
import AcceptInvite from "../../views/login/acceptInvite";

export default function AcceptInvitePage() {
  return <AcceptInvite />;
}
